@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.home.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringArrayResource

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.home.resources/"

@delegate:ResourceContentHash(557_587_339)
internal val Res.array.home_months: StringArrayResource by lazy {
      StringArrayResource("string-array:home_months", "home_months", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10, 208),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 128),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 84),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainArray0Resources(map: MutableMap<String, StringArrayResource>) {
  map.put("home_months", Res.array.home_months)
}
